export function formatDateTimeIntoDate (dateTimeAsString) {
    if (!dateTimeAsString) { return null; }
    const dateHours = dateTimeAsString.split(' ');
    const [year, month, day] = dateHours[0].split('-');

    return `${day}/${month}/${year}`;
}

export function getTodayDatePlusOneYear () {
    const now = new Date();
    const dateString = toLocaleDateString(addYears(now, 1));
    const hoursString = toLocaleTimeString(now);
    const [day, month, year] = dateString.split('/');

    return `${year}-${month}-${day} ${hoursString}`;
}

export function hasTheDateAlreadyPassed (dateTimeAsString) {
    const dateToCompare = new Date(dateTimeAsString);
    const currentDate = new Date();
    return currentDate > dateToCompare;
}

export function isDateTimeWithinDaysAhead(dateTimeAsString, daysAhead) {
    const daysFromNow = (new Date()).setDate((new Date()).getDate() + daysAhead);
    const targetDate = new Date(dateTimeAsString);

    return targetDate <= daysFromNow;
}

export function getNowDatetime(fileNameFormat = false) {
    const date = new Date();
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return fileNameFormat ?
        `${day}-${month}-${year}_${hours}-${minutes}-${seconds}` :
        `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;

}

function addYears (date, years) {
    date.setFullYear(date.getFullYear() + years);
    return date;
}

function toLocaleTimeString (date) {
    return date.toLocaleTimeString('pt-BR');
}

function toLocaleDateString (date) {
    return date.toLocaleDateString('pt-BR');
}

